import React, { ReactNode } from 'react';

interface FormSectionProps {
  title?: string;
  children: ReactNode;
  cardClassName?: string;
  className?: string;
}

export const FormSection: React.FC<FormSectionProps> = ({
  title,
  children,
  cardClassName,
  className,
}) => (
  <div className={`flex flex-col gap-5 w-full ${className ?? ''}`}>
    {title && (
      <h2 className="font-['Roboto'] text-[20px] font-bold leading-[1.4] text-[#004494]">
        {title}
      </h2>
    )}
    <div className={`bg-white rounded-[30px] ${cardClassName ?? 'p-6 flex flex-col gap-5'}`}>
      {children}
    </div>
  </div>
);
